
/* injects from baggage-loader */

/*
 * Module siter.io
 */

angular.module('siter.io', [
  'ui.bootstrap',
  'ui.tree',
  'ui-notification',
  'ngLocale',
  'restangular',
  'ui.router',
  'cgBusy',
  'infinite-scroll',
  'angularFileUpload',
  'contenteditable',
  'angular-growl',
  'ngAnimate',
  'ngCookies',
  'editor',
  'ivh.treeview',
  'pascalprecht.translate',
  'tmh.dynamicLocale',
  'ngTagsInput',
  'ng'
]);



// WEBPACK FOOTER //
// ./src/app/app-main/siter.module.js